<template>
  <v-btn :disabled="loading" :loading="loading" v-bind="$attrs" type="submit">
    <slot />
  </v-btn>
</template>
<script>
export default {
  inject: ['registerButton'],
  data() {
    return {
      loading: false,
    };
  },
  props: {
    hasLoader: { default: true, type: Boolean },
  },
  mounted() {
    if (this.hasLoader && this.registerButton) {
      this.registerButton(this);
    }
  },
};
</script>
